// extracted by mini-css-extract-plugin
export var grid = "HowDoesItWork-module--grid--0c129";
export var howDoesItWorkContainer = "HowDoesItWork-module--how-does-it-work-container--f519e";
export var item = "HowDoesItWork-module--item--49502";
export var itemContent = "HowDoesItWork-module--item-content--4bdf9";
export var itemIcon = "HowDoesItWork-module--item-icon--5187d";
export var title = "HowDoesItWork-module--title--2b98c";